export const STAR_VALUES = [1, 2, 3, 4, 5];
export const STAR_SIZE = 64;
const STAR_GAP = 4;
export const STAR_ROW_WIDTH = STAR_VALUES.length * STAR_SIZE + (STAR_VALUES.length - 1) * STAR_GAP;

export const starRatingRowSx = {
    display: 'grid',
    gridTemplateColumns: `repeat(${STAR_VALUES.length}, minmax(0, 1fr))`,
    gap: `${STAR_GAP}px`,
    width: '100%',
    maxWidth: STAR_ROW_WIDTH,
} as const;

export const starIconSx = {fontSize: STAR_SIZE, width: '100%', height: 'auto'};
